import { render, staticRenderFns } from "./ChallengesAccueil.vue?vue&type=template&id=32707b32&"
import script from "./ChallengesAccueil.vue?vue&type=script&lang=js&"
export * from "./ChallengesAccueil.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports